/**
 * Maps WebSocket error codes to user-friendly display messages.
 *
 * Error codes originate from:
 * - AFXTACOWebsocketLambda (e.g., DATA_HYGIENE_ERROR, MISSING_FIELDS, PROCESSING_ERROR)
 * - AFXTACOOrchestratorLambda (e.g., ORCHESTRATOR_FAILED)
 * - AFXTACOAgent (e.g., AGENT_ERROR)
 */

const ERROR_CODE_MESSAGES: Record<string, string> = {
  DATA_HYGIENE_ERROR:
    "The project or session you're trying to access is invalid.",
  MISSING_FIELDS: "The request was incomplete. Please try again.",
  PROCESSING_ERROR:
    "An error occurred while processing your request. Please try again.",
  ORCHESTRATOR_FAILED:
    "An error occurred while processing your request. Please try again.",
  AGENT_ERROR: "The AI assistant encountered an error. Please try again.",
};

const DEFAULT_ERROR_MESSAGE =
  "An error occurred while processing your request. Please try again.";

/**
 * Returns a user-friendly error message for the given error code.
 * Falls back to the raw errorMessage if no mapping exists, or a generic default.
 *
 * @param errorCode - The error code from the WebSocket error message
 * @param errorMessage - The raw error message from the backend (used as fallback)
 * @returns A user-friendly error string suitable for display in the chat
 */
export function getUserFriendlyErrorMessage(
  errorCode: string | null,
  errorMessage: string | null,
): string {
  if (errorCode && ERROR_CODE_MESSAGES[errorCode]) {
    return ERROR_CODE_MESSAGES[errorCode];
  }
  return errorMessage || DEFAULT_ERROR_MESSAGE;
}
